var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.id,"size":_vm.size,"centered":"","hide-header":true,"hide-header-close":true,"hide-footer":true},on:{"hidden":() => this.$emit('hidden')}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }